import { type PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';

import { Card } from '../../../../components';

import FailedIcon from './failed-icon';
import PassedIcon from './passed-icon';

interface ExamResultCardProps extends PropsWithChildren {
  variant: 'passed' | 'failed' | 'submitted';
  delayedDays?: number;
}

const iconVariantMap: Record<ExamResultCardProps['variant'], JSX.Element> = {
  passed: <PassedIcon />,
  submitted: <PassedIcon />,
  failed: <FailedIcon />,
};

const examResultTitleMap: Record<ExamResultCardProps['variant'], string> = {
  passed: 'examResult.passed',
  failed: 'examResult.failed',
  submitted: 'examResult.submitted',
};

function ExamResultCard(props: Readonly<ExamResultCardProps>) {
  const { t } = useTranslation();
  const { variant, delayedDays, children } = props;

  return (
    <Card className='mx-auto w-full max-w-200 p-10'>
      <div className='mx-auto flex w-105 flex-col items-center gap-6 text-center'>
        {iconVariantMap[variant]}
        <div className='flex flex-col gap-2'>
          <h3>
            <span>{t(examResultTitleMap[variant])}</span>
            <br />
            {delayedDays ? (
              <span>{t('examResult.certificateDelayedSend', { delayedDays })}</span>
            ) : null}
          </h3>
          <p className='text-text-secondary'>{t('examResult.description')}</p>
        </div>
        {children}
      </div>
    </Card>
  );
}

export default ExamResultCard;
